// import { Form, Col, DatePicker } from "antd";
// import Select from "react-select";
// import dayjs from "dayjs";

// const disablePastDates = (current) =>
//   current && current < dayjs().startOf("day");

// const calculateDuration = (endDateStr) => {
//   if (!endDateStr) return null;
//   const end = dayjs(endDateStr, "DD-MM-YYYY");
//   const today = dayjs().startOf("day");
//   const days = end.diff(today, "day");
//   return days > 0 ? days : 0;
// };

// const PlanDetailsSection = ({
//   formData,
//   errors,
//   planOption,
//   in_Menu_Options,
//   handleSelect,
//   handlePlanTypeChange,
//   handleInputChange,
//   setOrderSummary,
// }) => {
//   const selectStyles = (errorFieldName) => ({
//     control: (provided) => ({
//       ...provided,
//       borderColor: errors[errorFieldName] ? "#dc3545" : provided.borderColor,
//       boxShadow: errors[errorFieldName]
//         ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
//         : provided.boxShadow,
//       minHeight: 22,
//       height: 33,
//     }),
//   });

//   const existingEndDate = formData.end_date
//     ? dayjs(formData.end_date, "DD-MM-YYYY")
//     : null;
//   const isEndDateExpired =
//     existingEndDate && existingEndDate.isBefore(dayjs(), "day");

//   return (
//     <>
//       {/* Plan Name */}
//       <Col xs={24} sm={12}>
//         <Form.Item
//           label="Plan Name"
//           validateStatus={errors.plan_id ? "error" : ""}
//           help={errors.plan_id}
//         >
//           <Select
//             placeholder="Select Plan"
//             options={planOption}
//             value={
//               planOption.find((opt) => opt.value === formData.plan_id) || null
//             }
//             onChange={(selectedOption) =>
//               handleSelect("plan_id", selectedOption)
//             }
//             isDisabled={!formData.is_attorney}
//             styles={selectStyles("plan_id")}
//           />
//         </Form.Item>
//       </Col>

//       {/* End Date for Free Trial */}
//       {formData.customer_type == 2 && (
//         <Col xs={24} sm={12}>
//           <Form.Item
//             label="End Date"
//             validateStatus={errors.end_date ? "error" : ""}
//             help={errors.end_date}
//           >
//             {isEndDateExpired && (
//               <div
//                 style={{
//                   fontSize: 12,
//                   color: "#faad14",
//                   marginBottom: 4,
//                   fontWeight: 500,
//                 }}
//               >
//                 Current (expired): <strong>{formData.end_date}</strong> — select a new date
//               </div>
//             )}
//             <DatePicker
//               className="w-100"
//               format="DD-MM-YYYY"
//               size="large"
//               disabledDate={disablePastDates}
//               defaultPickerValue={dayjs()}
//               value={isEndDateExpired ? null : existingEndDate}
//               placeholder={isEndDateExpired ? "Select new end date" : "Select end date"}
//               onChange={(_date, dateString) => {
//                 const days = calculateDuration(dateString);
//                 handleInputChange({
//                   target: { name: "end_date", value: dateString },
//                 });
//                 setOrderSummary((prev) => ({
//                   ...prev,
//                   end_date: dateString || "-",
//                   trialDuration: days,
//                 }));
//               }}
//             />
//           </Form.Item>
//         </Col>
//       )}

//       {/* Plan Duration for Paid */}
//       {formData.customer_type == 1 && (
//         <Col xs={24} sm={12}>
//           <Form.Item
//             label="Plan Duration Type"
//             validateStatus={errors.plan_type ? "error" : ""}
//             help={errors.plan_type}
//           >
//             <Select
//               placeholder="Select Duration Type"
//               options={in_Menu_Options}
//               value={
//                 formData.plan_type
//                   ? in_Menu_Options.find(
//                       (option) => option.value === formData.plan_type,
//                     )
//                   : null
//               }
//               onChange={handlePlanTypeChange}
//               isDisabled={!formData.is_attorney}
//               styles={selectStyles("plan_type")}
//             />
//           </Form.Item>
//         </Col>
//       )}
//     </>
//   );
// };

// export default PlanDetailsSection;



import { Form, Col, Row, DatePicker } from "antd";
import Select from "react-select";
import dayjs from "dayjs";

const disablePastDates = (current) =>
  current && current < dayjs().startOf("day");

const calculateDuration = (endDateStr) => {
  if (!endDateStr) return null;
  const end = dayjs(endDateStr, "DD-MM-YYYY");
  const today = dayjs().startOf("day");
  const days = end.diff(today, "day");
  return days > 0 ? days : 0;
};

const PlanDetailsSection = ({
  formData,
  errors,
  planOption,
  in_Menu_Options,
  handleSelect,
  handlePlanTypeChange,
  handleInputChange,
  setOrderSummary,
}) => {
  const reactSelectStyles = (fieldName) => ({
    control: (base, state) => ({
      ...base,
      minHeight: 40,
      height: "auto",
      borderColor: errors[fieldName]
        ? "#dc3545"
        : state.isFocused
        ? "#4096ff"
        : "#d9d9d9",
      boxShadow: errors[fieldName]
        ? "0 0 0 2px rgba(220,53,69,.2)"
        : state.isFocused
        ? "0 0 0 2px rgba(5,145,255,.1)"
        : "none",
      "&:hover": {
        borderColor: errors[fieldName] ? "#dc3545" : "#4096ff",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      flexWrap: "nowrap",
      overflow: "hidden",
    }),
    singleValue: (base) => ({
      ...base,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    placeholder: (base) => ({
      ...base,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      flexShrink: 0,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  });

  const existingEndDate = formData.end_date
    ? dayjs(formData.end_date, "DD-MM-YYYY")
    : null;
  const isEndDateExpired =
    existingEndDate && existingEndDate.isBefore(dayjs(), "day");

  return (
    <>
      {/* Plan Name — always half-width alongside the next field */}
      <Col xs={24} sm={12}>
        <Form.Item
          label="Plan Name"
          validateStatus={errors.plan_id ? "error" : ""}
          help={errors.plan_id}
        >
          <Select
            placeholder="Select Plan"
            options={planOption}
            value={
              planOption.find((opt) => opt.value === formData.plan_id) || null
            }
            onChange={(selectedOption) =>
              handleSelect("plan_id", selectedOption)
            }
            isDisabled={!formData.is_attorney}
            menuPortalTarget={document.body}
            styles={reactSelectStyles("plan_id")}
          />
        </Form.Item>
      </Col>

      {/* End Date for Free Trial */}
      {formData.customer_type == 2 && (
        <Col xs={24} sm={12}>
          <Form.Item
            label="End Date"
            validateStatus={errors.end_date ? "error" : ""}
            help={errors.end_date}
          >
            {isEndDateExpired && (
              <div
                style={{
                  fontSize: 12,
                  color: "#faad14",
                  marginBottom: 4,
                  fontWeight: 500,
                }}
              >
                Current (expired): <strong>{formData.end_date}</strong> —
                select a new date
              </div>
            )}
            <DatePicker
              style={{ width: "100%" }}
              format="DD-MM-YYYY"
              size="large"
              disabledDate={disablePastDates}
              defaultPickerValue={dayjs()}
              value={isEndDateExpired ? null : existingEndDate}
              placeholder={
                isEndDateExpired ? "Select new end date" : "Select end date"
              }
              onChange={(_date, dateString) => {
                const days = calculateDuration(dateString);
                handleInputChange({
                  target: { name: "end_date", value: dateString },
                });
                setOrderSummary((prev) => ({
                  ...prev,
                  end_date: dateString || "-",
                  trialDuration: days,
                }));
              }}
            />
          </Form.Item>
        </Col>
      )}

      {/* Plan Duration for Paid */}
      {formData.customer_type == 1 && (
        <Col xs={24} sm={12}>
          <Form.Item
            label="Plan Duration Type"
            validateStatus={errors.plan_type ? "error" : ""}
            help={errors.plan_type}
          >
            <Select
              placeholder="Select Duration Type"
              options={in_Menu_Options}
              value={
                formData.plan_type
                  ? in_Menu_Options.find(
                      (option) => option.value === formData.plan_type,
                    )
                  : null
              }
              onChange={handlePlanTypeChange}
              isDisabled={!formData.is_attorney}
              menuPortalTarget={document.body}
              styles={reactSelectStyles("plan_type")}
            />
          </Form.Item>
        </Col>
      )}

      {/* Optional custom end date for Paid subscriptions */}
      {formData.customer_type == 1 && (
        <Col xs={24} sm={12}>
          <Form.Item label="End Date">
            <DatePicker
              key={formData.end_date || "paid-end-date"}
              style={{ width: "100%" }}
              format="DD/MM/YYYY"
              size="large"
              disabledDate={disablePastDates}
              defaultValue={
                formData.end_date
                  ? dayjs(formData.end_date, "DD/MM/YYYY")
                  : undefined
              }
              placeholder="Select end date"
              allowClear
              onChange={(_date, dateString) => {
                handleInputChange({
                  target: { name: "end_date", value: dateString },
                });
                setOrderSummary((prev) => ({
                  ...prev,
                  end_date: dateString || "-",
                }));
              }}
            />
          </Form.Item>
        </Col>
      )}
    </>
  );
};

export default PlanDetailsSection;

